<script lang="ts">
    import { link } from 'svelte-spa-router';

    export let title: string;
    export let subtitle: string = '';
    export let features: string[] = [];
    export let historyHref: string = '';
    export let historyLabel: string = 'View past runs';
    export let historyCount: number | null = null;
</script>

<section class="agent-hero">
    <div class="hero-left">
        <h1 class="hero-title">{title}</h1>
        {#if subtitle}<p class="hero-subtitle">{subtitle}</p>{/if}
        {#if features.length}
            <ul class="hero-features">
                {#each features as feature}
                    <li>
                        <i class="check circle icon" aria-hidden="true"></i>
                        <span>{feature}</span>
                    </li>
                {/each}
            </ul>
        {/if}
        {#if historyHref}
            <a use:link href={historyHref} class="history-link">
                <i class="history icon" aria-hidden="true"></i>
                <span>{historyLabel}{historyCount !== null ? ` (${historyCount})` : ''}</span>
            </a>
        {/if}
    </div>
    <div class="hero-right">
        <slot name="creator" />
    </div>
</section>

<style>
    .agent-hero {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: var(--space-8);
        align-items: center;
        padding: var(--space-6) 0;
    }

    .hero-title {
        font-size: var(--text-4xl);
        font-weight: 600;
        color: var(--grey);
        line-height: 1.1;
        margin: 0 0 var(--space-4) 0;
        text-wrap: balance;
    }

    .hero-subtitle {
        font-size: var(--text-base);
        color: var(--grey-secondary);
        line-height: 1.6;
        margin: 0 0 var(--space-5) 0;
        max-width: 44ch;
    }

    .hero-features {
        list-style: none;
        padding: 0;
        margin: 0 0 var(--space-5) 0;
    }

    .hero-features li {
        display: flex;
        align-items: flex-start;
        gap: var(--space-2);
        padding: var(--space-2) 0;
        color: var(--grey);
        font-size: var(--text-sm);
    }

    .hero-features :global(i.check.circle.icon) {
        color: var(--primary);
        margin-top: .1rem;
    }

    .history-link {
        display: inline-flex;
        align-items: center;
        gap: var(--space-2);
        color: var(--secondary);
        font-size: var(--text-sm);
        text-decoration: none;
    }

    .history-link:hover { color: var(--primary); }
    .history-link:focus-visible {
        outline: none;
        box-shadow: var(--focus-ring);
        border-radius: var(--radius-input);
    }

    @media (max-width: 900px) {
        .agent-hero {
            grid-template-columns: 1fr;
            gap: var(--space-5);
        }
        .hero-title { font-size: var(--text-3xl); }
    }
</style>
